// ADR-133: Reports → Ingestion Sync Runs (radar-api /api/reports/ingestion-sync-runs/…).
import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';

const BASE = `${API_BASE_URL}/reports/ingestion-sync-runs`;

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    if (Array.isArray(value)) {
      if (value.length > 0) {
        search.set(key, value.join(','));
      }
      return;
    }
    search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

const rethrow = (error, fallback) => {
  throw new ApiError(error?.message || fallback, error?.status || 500, error?.data || null);
};

export const ingestionSyncRunsApi = {
  listRuns: async ({ provider, syncType, status, mode, trigger, batchId, limit = 50, cursor } = {}) => {
    try {
      return await authenticatedApi.get(`${BASE}/runs${buildQuery({ provider, syncType, status, mode, trigger, batchId, limit, cursor })}`);
    } catch (error) {
      return rethrow(error, 'Failed to list sync runs');
    }
  },

  /** @returns {Promise<{ run, batch, sections: [{ sectionKey, itemCount, hidden, declaredItemCount? }] }>} */
  getRun: async (runId) => {
    try {
      return await authenticatedApi.get(`${BASE}/runs/${runId}`);
    } catch (error) {
      return rethrow(error, 'Failed to load the sync run');
    }
  },

  listItems: async (runId, { section, employeeId, q, limit = 50, cursor } = {}) => {
    try {
      return await authenticatedApi.get(`${BASE}/runs/${runId}/items${buildQuery({ section, employeeId, q, limit, cursor })}`);
    } catch (error) {
      return rethrow(error, 'Failed to load the run items');
    }
  },

  /** The full stored record (requires read IngestionSyncRunRecord). */
  getItem: async (itemId) => {
    try {
      return await authenticatedApi.get(`${BASE}/items/${itemId}`);
    } catch (error) {
      return rethrow(error, 'Failed to load the record');
    }
  },

  /** Always a real run of the provider's scheduler pipeline (no dry run, ADR-133 §6.5). */
  triggerNow: async ({ provider }) => {
    try {
      return await authenticatedApi.post(`${BASE}/trigger-now`, { provider });
    } catch (error) {
      return rethrow(error, 'Failed to trigger the sync');
    }
  },
};

export default ingestionSyncRunsApi;
